import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { del, get, post } from '../_services/apiService';
import { API_URL } from '../_services/apiUrl';
import toast from 'react-hot-toast';
import { getGuestId } from '../utils/guestUtils';
import { decryptId } from '../utils/cryptoId';

// Create a context
const WishlistContext = createContext();

// Create a custom hook to use the Wishlist context
export const useWishlist = () => useContext(WishlistContext);

// Wishlist provider to wrap the app and provide the wishlist state
export const WishlistProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn'));
  // const isLoggedIn = localStorage.getItem('isLoggedIn');

  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [guestIdInt, setGuestIdInt] = useState(null);
  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const [address, setAddress] = useState([]);
  // const [ipAddress, setIpAddress] = useState("34.21.9.50");
  const [ipAddress, setIpAddress] = useState(null);

  useEffect(() => {
    const FetchIPaddress = async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        setIpAddress(data?.ip || "unknown");
      } catch (err) {
        setIpAddress("unknown");
      }
    }
    FetchIPaddress();
  }, [])

  // Fetch wishlist
  const fetchWishlist = useCallback(async () => {
    const token = localStorage.getItem('token');
    const loginStatus = localStorage.getItem('isLoggedIn');

    if (!token || loginStatus !== 'true') {
      setWishlist([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const response = await get(API_URL.wish_list);

      if (response?.status && Array.isArray(response?.data)) {
        setWishlist(response.data);
      } else {
        setWishlist([]);
      }
    } catch (error) {
      setWishlist([]);
    } finally {
      setLoading(false);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    fetchWishlist();
  }, [fetchWishlist]);

  // Add product to wishlist
  const addToWishlist = async (formData) => {
    try {
      const payload = {
        product_id: Number(formData?.product_id || 0),
      };

      if (!payload.product_id) {
        toast.error('Invalid product id');
        return;
      }

      const response = await post(API_URL.add, payload);


      if (response?.status) {
        await fetchWishlist();
      } else {
        toast.error(response?.message || 'You have already added this product to your wishlist!');
      }
    } catch (error) {
      toast.error('Failed to add this product to your wishlist!');
    }
  };

  // Remove product from wishlist
  const removeFromWishlist = async (id) => {

    try {
      const productId = Number(id);

      if (!productId) {
        toast.error('Invalid product id');
        return;
      }

      // IMPORTANT:
      // DELETE request me body ko `data` ke andar bhejna hota hai
      const response = await del(API_URL.remove, {
        data: {
          product_id: productId,
        },
      });


      if (response?.status) {
        await fetchWishlist();
      } else {
        toast.error(response?.message || 'Failed to remove product from wishlist!');
      }
    } catch (error) {
      toast.error('Failed to delete this product from your wishlist!');
    }
  };

  // Load guest id
  useEffect(() => {
    const loadGuestId = async () => {
      try {
        const { int } = await getGuestId();
        setGuestIdInt(int);
      } catch (err) {
      }
    };

    loadGuestId();
  }, []);

  const loadAddress = useCallback(async () => {
    try {
      const response = await get(API_URL.getAddress, { guest_id: guestIdInt });

      // if (response?.status) {
      setAddress(response || []);
      // } else {
      //     setAddress([]);
      // }

    } catch (error) {
      setAddress([]);
    }
  }, [guestIdInt]);

  useEffect(() => {
    if (!guestIdInt) return;
    loadAddress();
  }, [guestIdInt, loadAddress]);

  return (
    <WishlistContext.Provider
      value={{
        wishlist,
        setWishlist,
        loading,
        addToWishlist,
        removeFromWishlist,
        isLoggedIn,
        setIsLoggedIn,
        fetchWishlist,
        guestIdInt,
        address,
        ipAddress,
      }}
    >
      {children}
    </WishlistContext.Provider>
  );
};
